import { StateCreator } from "zustand";
import { setStoredListenerName } from "../utils/listenerNameStorage";
export interface IQuestionWithoutRegisterSlice {
	listenerFullName: string;
	setListenerFullName: (fullName: string) => void;
	question: string;
	setQuestion: (question: string) => void;
	showSuccessToast: boolean;
	setShowSuccessToast: (showToast: boolean) => void;
	showFailToast: boolean;
	setShowFailToast: (showToast: boolean) => void;
	showForm: boolean;
	setShowForm: (showForm: boolean) => void;
}

type StoreWithLiveId = IQuestionWithoutRegisterSlice & { liveId: number | null };

export const questionWithoutRegisterSlice: StateCreator<IQuestionWithoutRegisterSlice> = (set, get) => ({
	listenerFullName: "",
	setListenerFullName: (fullName) => {
		const trimmed = fullName.trim();
		set({ listenerFullName: fullName });
		const liveId = (get() as StoreWithLiveId).liveId;
		setStoredListenerName(liveId, trimmed);
	},
	question: "",
	setQuestion: (question) => set({ question }),
	showSuccessToast: false,
	setShowSuccessToast: (showSuccessToast) => set({ showSuccessToast }),
	showFailToast: false,
	setShowFailToast: (showFailToast) => set({ showFailToast }),
	showForm: false,
	setShowForm: (showForm) => set({ showForm }),
});
